import React, { useState, useEffect, useCallback } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { Scrollbars } from 'react-custom-scrollbars';
import dayjs from "dayjs";
import clsx from 'clsx';
import axios from 'axios';
import { Oval } from 'react-loader-spinner'
import { CSVDownload } from "react-csv";
import ja from "date-fns/locale/ja";
import fileDownload from 'js-file-download';
import DatePicker from "react-datepicker";
import { useCookies } from 'react-cookie';
import Cookies from 'universal-cookie'
import "react-datepicker/dist/react-datepicker.css"
import { useDeleteModal, useCreateModal, useEditData, useVermins, useTempMove} from 'src/stores';
import { Radio, Table, Button, ContentsLayout, ContentsHeader, Select } from 'src/components';
import styles from './Data.module.scss';
import { ecology, trapList, display, prevention, damage_category, vermin_category, damage_implementation } from 'src/utils/choises';

export type FormValues = {
  kinds_vermin: string[];
  start_date: string;
  end_date: string;
  id: string[] | undefined;
  category: string;
  occurrence_start: string;
  occurrence_stop: string;
  all: string;
  displayability: string[];

  report_exist : number; //240417 Add Uduki
};

var s_d:string | undefined = undefined;
var e_d:string | undefined = undefined;
var s_t:string | undefined = undefined;
var e_t:string | undefined = undefined;
var v_k:string[] | undefined = undefined;
var d_v:string[] | undefined = undefined;
var r_e:number | undefined = undefined; //240417 Add Uduki

// 検索結果一覧の各データの型
export type Vermin = {
  mesh_number: string;
  trap_hunting_name: string;
  vermin_address: string;
  vermin_count: number;
  vermin_herd: string;
  vermin_discovery_date: string;
  vermin_discovery_time: string;
  vermin_ecology: string;
  vermin_geom: {
    coordinates: {
      latitude: string;
      longitude: string;
    };
  };
  vermin_kind_id: number;
  vermin_latitude: string;
  vermin_longitude: string;
  vermin_id: number;
  trap_id: number;
  camera_id: number;
  vermin_kind_name: string;
  vermin_register_date: string;
  vermin_remarks: string;
  vermin_update_date: string;
  vermin_displayability_name: string;
  vermin_is_deleted: boolean;
  vermin_ecology_name: string;
  update_user_id: number;
  update_user_name: string;
  vermin_picture: string;

  report_id: number;//20240416 Add Uduki
};

export type Trap = {
  trap_id: number;
  trap_hunting_id: number;
  trap_hunting_name: string;
  vermin_kind_id: number;
  vermin_kind_name: string;
  trap_admin: string;
  trap_admin_tel: string;
  trap_start: string;
  trap_stop: string;
  trap_result: string;
  trap_mistake: boolean;
  trap_mistake_log: string;
  trap_latitude: string;
  trap_longitude: string;
  trap_address: string;
  trap_log_latitude: string;
  trap_log_longitude: string;
  trap_count: number;
  camera_id: string;
  trap_remarks: string;
  trap_displayability: string;
  trap_deleted: boolean;
  trap_update_date: string;
  update_user_id: number;
  update_user_name: string;
};

export type Prevention_faci = {
  prev_faci_id: number;
  prev_faci_type_id: number;
  prev_faci_type_name: string;
  prev_faci_delivery_year: string;
  prev_faci_delivery_date: string;
  prev_faci_admin: string;
  prev_faci_admin_tel: string;
  prev_faci_adress: string;
  prev_faci_distance: string;
  prev_faci_geom_text: string;
  prev_faci_remarks: string;
  prev_faci_displayability: number;
  prev_faci_deleted: number;
  prev_faci_update_date: number;
  update_user_id: string;
  update_user_name: string;
};

export type Camera = {
  camera_id: number;
  camera_latitude: string;
  camera_longitude: string;
  camera_direction: string;
  trap_id: number;
  camera_start: string;
  camera_stop: string;
  camera_remarks: string;
  camera_displayability: string;
  camera_deleted: boolean;
  camera_update_date: string;
  update_user_id: number;
  update_user_name: string;
};

export type Damage = {
  damage_type_id: number;
  vermin_kind_id: number;
  damage_discovery_date: string;
  damage_contents: string;
  damage_implementation: string;
  damage_implementation_date: string;
  damage_implementation_time: string;
  damage_implementation_name: string;
  damage_latitude: string;
  damage_longitude: string;
  damage_remarks: string;
  damage_displayability: string;
  damage_deleted: boolean;
  damage_update_date: string;
  update_user_id: number;
  update_user_name: string;
  damage_id: number;
  damage_countermeasures: string;
  damage_displayability_name: string;
  vermin_kind_name: string;
  damage_type_name: string;

  report_id: number;//20240416 Add Uduki
};
//230206追加
export type Indpin = {
  indpin_id: number;
  indpin_label: string;
  indpin_latitude: string;
  indpin_longitude: string;
  indpin_comment: string; // 20250417 Add Uduki
  indpin_displayability: string;
  indpin_deleted: boolean;
};
// 20240419 報告書用の型作成 Add Uduki
export type Report = {
  report_kind: number;
  information_id: number;

  report_dt: string;
  receptionist_nm: string;
  reporter_nm: string;
  waypoint: string;
  receptionist_ts: string;

  report_nm: string;
  report_tel: string;
  discovery_ts: string;
  discovery_address: string;
  latitude: string;
  longitude: string;
  administrative_district: string;
  vermin_kind_id: string;
  vermin_nm: string;
  head_count: number;
  ecology: number;
  ecology_nm: string;
  report_st: string;

  confirmation_ts: string;
  confirmer: string;
  witness: string;
  witness_tel: string;
  zoning: number;
  zoning_st: string;

  contact_rp: string;

  hdamage_nt: string;
  crop_nm: string;
  crop_ps: number;
  crop_co: string;
  crop_ar: string;
  crop_nt: string;
  digging_up_dp: number;
  digging_up_nt: string;
  damage_other: string;

  attachKind: string;
  attach_other_r: string;

  remarks: string;
};

const resize_x = Number(`${process.env.REACT_APP_DATA_REMARKS_LIMIT_WIDTH}`);

/**
 * Data コンポーネント
 * 鳥獣害のデータ管理、データを削除したりCSV出力する
 * @returns React.ReactNode
 */
const Data: React.FC = () => {
  /**
   * 一括操作プルダウン表示判定フラグ
   */
  const [isPulldownModal, setIsPulldownModal] = useState(false);

  /**
   * 一括操作でどれを選んだか保持
   */
  const [operationValue, setOperationValue] = useState('');

  /**
   * 論理削除で削除するidの配列
   */
  const deleteDataId = useDeleteModal(state => state.deleteDataId);

  /**
   * 削除、公開範囲完了時のモーダル出現フラグ
   */
  const [successApiModal, setSuccessApiModal] = useState(false);

  /**
   * 情報登録モーダルフラグ
   * 20240416 Add Uduki createReportModalOpen
   */
  const [createModalToggle, createDamageModalOpen, createTrapModalOpen, createCameraModalOpen, createPictureModalOpen, createPrevModalOpen, createReportModalOpen] = useCreateModal(state => [state.createModalToggle, state.createDamageModalOpen, state.createTrapModalOpen, state.createCameraModalOpen, state.createPictureModalOpen, state.createPrevModalOpen, state.createReportModalOpen]);

/**
 * 一時的ページ移動フラグ
 */
  const [T_M, falseT_M, Start_Day, setS_D, End_Day, setE_D] = useTempMove(state => [state.T_M, state.falseT_M, state.Start_Day, state.setS_D, state.End_Day, state.setE_D]);

  /**
* 情報削除モーダルの開閉状態管理ストアのプロパティとメソッド
* ┬ isDeleteModal: boolean
* ├ true 開く
* └ false 閉じる
* ┬ deleteModalClose: () => void
* └ isDeleteModal の真偽値をfalseにする
* ┬ deleteModalToggle: () => void
* └ isDeleteModalの真偽値をtrueにする
* ┬ deleteDataInput: (data: string[], searchKeyword: object) => void;
* └ データを論理削除するために必要なIDの配列と検索条件を保持
*/
  const [deleteModalClose, deleteModalToggle, deleteDataInput, isDeleteModal] = useDeleteModal(state => [state.deleteModalClose, state.deleteModalToggle, state.deleteDataInput, state.isDeleteModal]);

  /**
   * 削除Cookie用
   */
  const cookies = new Cookies();

  /**
   * cookie
   */
  const [cookie] = useCookies(["verminData"]);

  /**
* 新規情報登録ハンドラ
*/
  const [vermins, setVermins, setSearchCondition] = useVermins(state => [state.vermins, state.setVermins, state.setSearchCondition]);

  /**
   * API通信中判定フラグ
   */
  const [loading, setLoading] = useState(false);

  /**
* 編集モーダル開閉時のデータ格納ストア
* 20240410 Add Uduki 報告書用ストア追加
*/
  const [setEditVerminData, setEditDamageData, setEditTrapData, setEditCameraData, setEditPrevData, setexpPictureData, setEditReportData] = useEditData(state => [state.setEditVerminData, state.setEditDamageData, state.setEditTrapData, state.setEditCameraData, state.setEditPrevData, state.setexpPictureData, state.setEditReportData]);

  /**
   * フォームを管理するカスタムフック
   * register を適用したフィールドの値を handleSubmit で取得できる
   * See https://react-hook-form.com/api/useform
   * @example
   * <Form onSubmit={handleSubmit(submit)}>
   *   <input {...register('field_name')} />
   *   ...
   * </Form>
   */
  const { handleSubmit, register, watch, setValue, resetField, control, reset, formState: { errors } } = useForm<FormValues>({
    defaultValues: {
      category: T_M ? "prevention_faci" : "vermin",
      //category: "vermin",
      kinds_vermin: ["1"],
      displayability: ["0", "1", "2", "3"],
      id: [],
      all: '1',
      report_exist: 0,//240417 Add Uduki
    }
  }
  );

  /**
   * 全選択および全解除ラジオボタン選択時の動作ハンドラ
   */
  const handleAllSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === '2') {
      resetField('id');
      const valuesIdList: any = (watch('category') === 'vermin') && vermins?.filter((vermin: Vermin) => !vermin.vermin_is_deleted).map((vermin: Vermin) => JSON.stringify(vermin)) || watch('category') === 'trap' && vermins?.filter((trap: Trap) => !trap.trap_deleted).map((trap: Trap) => { return JSON.stringify(trap) }) ||
        watch('category') === 'prevention_faci' && vermins?.filter((prev: Prevention_faci) => !prev.prev_faci_deleted).map((prev_faci: Prevention_faci) => { return JSON.stringify(prev_faci) }) ||
        watch('category') === 'camera' && vermins?.filter((camera: Camera) => !camera.camera_deleted).map((camera: Camera) => { return JSON.stringify(camera) }) ||
        watch('category') === 'damage' && vermins?.filter((damage: Damage) => !damage.damage_deleted).map((damage: Damage) => { return JSON.stringify(damage) })
      setValue('id', valuesIdList);
    } else {
      resetField('id');
    }
  }, [resetField, setValue, vermins, watch])

  /**
  * 削除
  * @example
  * <Button onClick={handleSearchReset}>...</Button>
  */
  const handleDeleteModal = useCallback(() => {
    deleteModalToggle();
  }, [deleteModalToggle]);

  /**
   * 編集ボタン押下時、情報登録モーダル出現と編集で扱うデータ格納ハンドラ
   * @param e
   * @param vermin
   */
  const handleEdit = useCallback((e: any, data: Vermin | Damage | Trap| Camera| Prevention_faci) => {
    e.stopPropagation();
    setSearchCondition(watch());
    if (watch('category') === 'vermin') {
      setEditVerminData(data as Vermin)
      createModalToggle()
    } else if (watch('category') === 'damage') {
      setEditDamageData(data as Damage)
      createDamageModalOpen()
    } else if (watch('category') === 'trap') {
      setEditTrapData(data as Trap)
      createTrapModalOpen()
    } else if (watch('category') === 'camera') {
      setEditCameraData(data as Camera)
      createCameraModalOpen()
    } else if (watch('category') === 'prevention_faci') {
      setEditPrevData(data as Prevention_faci)
      createPrevModalOpen()
    }
  }, [])
/**
 * 画像拡大モーダル を表示するハンドラ 画像20230407追記
 * @example
 * <Button onClick={pictureEditModal} ... />
 */
  const pictureEditModal = useCallback((data: Vermin) => {
    if (watch('category') === 'vermin') {
      setexpPictureData(data.vermin_picture)
      createPictureModalOpen()
    }
  }, []);

  /**
   * 報告書ボタン押下時、報告書モーダル出現と編集で扱うデータ格納ハンドラ
   * @param e
   * @param par_report_kind 元データのレポート種別(1:害獣、2:罠)
   * @param par_report_id 各データの種別ごとのID
   * 20240416 Add Uduki 
   */
    const handleReportEdit = useCallback((e: any, report_kind: number, information_id:number) => {
      e.stopPropagation();
      setSearchCondition(watch());
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/report_data`, {
        report_kind:report_kind,
        information_id:information_id,
      },{
        headers: { 
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then((res) => {
        if(res.data.features){
          setEditReportData(res.data.features);
          createReportModalOpen();
        }
      }).catch(async (err) => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      })
    }, [])

  /**
   * 報告書ダウンロードボタン押下時、報告書をダウンロードするハンドラ
   * @param e
   * @param par_report_kind 元データのレポート種別(1:害獣、2:罠)
   * @param par_report_id 各データの種別ごとのID
   * 20240416 Add Uduki 
   */
      const reportPDFDouwnload = useCallback((e: any, par_report_kind: number, par_information_id:number, par_report_id: number) => {
        e.stopPropagation();
        setLoading(true);
        axios.post(`${process.env.REACT_APP_DEV_API_URL}/pdf/export/report_data`, {
          report_kind:par_report_kind,
          information_id:par_information_id,
        },{
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
          //文字化け対策のバイナリデータ修正
        }).then((res) => {
          const file_name = '有害鳥獣出没現地確認報告書_No.'+String(par_report_id)+'_'+dayjs().format('YYYYMMDD_HHmmss')+'.pdf';
          fileDownload(res.data, file_name)
        }).catch(async (err) => {
          //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
          if (err?.response?.data?.message === "Unauthenticated.") {
            await cookies.remove('verminData');
            await window.location.replace('/');
          }
        }).finally(() => {
          setLoading(false);
        });
      }, [])

  /**
   * submitイベントのコールバック関数
   * @example
   * handleSubmit(search)
   */
  const search: SubmitHandler<FormValues> = async (data) => {
    //Loading表示
    setLoading(true);
    const start_date = (T_M && Start_Day!==null) ? Start_Day : data.start_date && dayjs(data.start_date).format("YYYY/MM/DD")
    const end_date = (T_M && End_Day!==null) ? End_Day : data.end_date && dayjs(data.end_date).format('YYYY/MM/DD')
    const occurrence_start = data.occurrence_start && dayjs(data.occurrence_start).format('HH:mm')
    const occurrence_stop = data.occurrence_stop && dayjs(data.occurrence_stop).format('HH:mm')
    const kinds_vermin = (watch('category') === 'vermin' || watch('category') === 'damage' || watch('category') === 'trap') ? data.kinds_vermin : undefined;
    const displayability = data.displayability;
    const report_exist = data.report_exist;//240417 Add Uduki
    s_d = start_date;
    e_d = end_date;
    s_t = occurrence_start;
    e_t = occurrence_stop;
    v_k = kinds_vermin;
    d_v = displayability;
    r_e = report_exist;//240417 Add Uduki
    if(watch('category') == "prevention_faci"){
      if(s_d){
        setS_D(s_d);
      }
      if(e_d){
        setE_D(e_d);
      }
    }
    await axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/${watch('category')}`,
      {
        params: {
          kinds_vermin,
          start_date,
          end_date,
          client_code: cookie?.verminData?.client_code,
          start_time: occurrence_start,
          end_time: occurrence_stop,
          management_search: 'TRUE',
          displayability: cookie?.verminData?.user_kind_id === 3 ? displayability : null,
          report_exist,//240417 Add Uduki
        }, headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
      }).then((data) => {
        resetField('id');
        resetField('all');
        setVermins(data.data.results)
      }).catch(async err => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      })
    //通信完了後Loading非表示
    setLoading(false)
  };

  //何件選択しているかを保持
  const [idCount, setIdCount] = useState<number>();

  /**
   * 一括操作実行ハンドラ
   */
  const handleExecution = useCallback(async () => {
    setLoading(true)
    //データ種別毎のIDをdataIdListに格納
    const tmpIdList = await watch('id')?.map((value: any) => {
      return (
        watch('category') === 'vermin' && JSON.parse(value).vermin_id ||
        watch('category') === 'trap' && JSON.parse(value).trap_id ||
        watch('category') === 'prevention_faci' && JSON.parse(value).prev_faci_id ||
        watch('category') === 'camera' && JSON.parse(value).camera_id ||
        watch('category') === 'damage' && JSON.parse(value).damage_id
      )
    })
      || [''];
    await deleteDataInput(tmpIdList, watch());

    //POSTするため文字列を対応する数値に
    const displayability = (operationValue === "ログイン閲覧者公開" && 1) || (operationValue === "登録修正論理削除権限者公開" && 2) || (operationValue === "管理者公開" && 3)
    if (operationValue === "CSVダウンロード") {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/csv/export`, {
        [watch('category')]: vermins,
        id: tmpIdList,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
        //文字化け対策のバイナリデータ修正
      }).then((res) => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([bom, res.data], { type: 'text/csv' });
        fileDownload(blob, `${dayjs().format('YYYYMMDD_HHmmss')}.csv`);
      }).catch(async (err) => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    } else if (operationValue === "削除" || operationValue === "全体公開") {
      setIdCount(watch('id')?.length);
      handleDeleteModal();
    }else if (operationValue === "表示情報一括ダウンロード"){
      const start_date = s_d;
      const end_date = e_d;
      const occurrence_start = s_t;
      const occurrence_stop = e_t;
      const kinds_vermin = v_k;
      const report_exist = r_e;
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/csv/export`, {
        [watch('category')]: vermins,
        kinds_vermin,
        start_date,
        end_date,
        report_exist,
        start_time: occurrence_start,
        end_time: occurrence_stop,
        client_code: cookie?.verminData?.client_code,
        //management_search: cookie.verminData.user_kind_id === 2 ? 'value' : null,
        management_search: 'TRUE',
        displayability: cookie?.verminData?.user_kind_id === 3 ? d_v : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
        //文字化け対策のバイナリデータ修正
      }).then((res) => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([bom, res.data], { type: 'text/csv' });
        fileDownload(blob, `${dayjs().format('YYYYMMDD_HHmmss')}.csv`);
      }).catch(async (err) => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    } else {

      //ログイン閲覧者公開、登録修正論理削除権限者公開、管理者公開選択時
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update_displayability`, {
        id: tmpIdList,
        displayability,
        [watch('category') === "prevention_faci" ? "prev_faci" : watch('category')]: '[]',
      }, {
        headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
      }).then(() => search(watch())).catch(async (err) => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    }

    setLoading(false)
  }, [cookie?.verminData?.api_token, handleDeleteModal, operationValue, watch])

  /**
   * 検索結果をリセットするハンドラ
   * @example
   * <Button onClick={handleSearchReset}>...</Button>
 */
  const handleSearchReset = useCallback(() => {
    setVermins([]);
    reset();
  }, [reset]);

  /**
   * データ種別を変更する際のハンドラ
   */
  const handleChangeCategory = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    setVermins([])
    await reset();
    setValue('category', e.target.value);
  }, [reset, setVermins])

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  /**
   * 選択した項目を論理削除するハンドラ
   */
  const handleDataDeleted = () => {
    setLoading(true);
    deleteModalClose();
    if (operationValue === '削除') {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/vermins/soft-delete`, { [watch('category') === "prevention_faci" ? "prev_faci" : watch('category')]: deleteDataId }, { headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` } }).then(async () => {
        await search(watch());
        await setSuccessApiModal(true);
      }
      ).catch(async (err) => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    } else {
      //全体公開選択時
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update_displayability`, {
        id: deleteDataId,
        displayability: 0,
        [watch('category') === "prevention_faci" ? "prev_faci" : watch('category')]: '[]',
      }, { headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` } }).then(async () => {
        await search(watch());
        await setSuccessApiModal(true);
      }).catch(async err => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    }
    setLoading(false);
  }

  /**
   * 一括操作プルダウン項目選択時
   */
  const handleSelect = useCallback((e: any) => {
    setOperationValue(e.target.value);
    setIsPulldownModal(false);
  }, [])

  /**
   * 新規登録情報モーダルボタン押下時
   */
  const handleSelectCreateModal = useCallback(() => {
    setSearchCondition(watch())
    falseT_M();
    //データ種別の値によってモーダルを出し分ける
    if (watch('category') === 'vermin') {
      createModalToggle();
    } else if (watch('category') === 'damage') {
      createDamageModalOpen();
    } else if (watch('category') === 'trap') {
      createTrapModalOpen();
    } else if (watch('category') === 'camera') {
      createCameraModalOpen();
    } else if (watch('category') === 'prevention_faci') {
      createPrevModalOpen();
    }
  }, [createPrevModalOpen, createCameraModalOpen, createTrapModalOpen, createDamageModalOpen, createModalToggle, watch])

  /**
   * 防止施設位置情報登録後に戻ってきた時の処理 20230414追記
   */
  useEffect(() =>{
    if(T_M){
      search(watch());
      falseT_M();
    }else{
      setS_D(null);
      setE_D(null);
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(search)} className={styles.form}>
      {loading &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay}>
            <Oval
              ariaLabel="loading-indicator"
              height={75}
              width={75}
              strokeWidthSecondary={1}
              color="#3a6468"
              secondaryColor="white"
            />
          </div>
        </div>
      }

      {
        /**
         * 削除および一般公開成功モーダル
         */
      }
      {successApiModal &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay} onClick={() => setSuccessApiModal(false)}></div>
          <div className={styles.modalCard}>
            <p className={styles.modalTitle}>{operationValue === "削除" ? "削除確認" : "公開確認"}</p>
            <p>選択した{idCount}件の情報を{operationValue === "削除" ? "削除" : "一般公開"}しました
            </p>
            <div className={styles.modalCenter}>
              <Button onClick={() => setSuccessApiModal(false)} variant="cancel">確認しました</Button>
            </div>
          </div>
        </div>
      }

      {
        /**
         * 削除および一般公開前確認モーダル
         */
      }
      {isDeleteModal &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay} onClick={deleteModalClose}></div>
          <div className={styles.modalCard}>
            <p className={styles.modalTitle}>{operationValue === "削除" ? "削除確認" : "公開確認"}</p>
            <p>選択した{idCount}件の{operationValue === "削除" ? "登録情報は削除されます。" : "一般公開されます"}
            </p>
            <p>
              よろしいですか？
            </p>
            {operationValue === "削除" &&
              <p className={styles.confirmText}>
                この操作は取り消せません
              </p>
            }
            <div className={styles.modalFooter}>
              <Button variant="cancel" onClick={deleteModalClose}>いいえ</Button>
              <Button onClick={handleDataDeleted}>はい</Button>
            </div>
          </div>
        </div>
      }
      <ContentsLayout>
        <ContentsHeader title="データ管理">
          <Button onClick={handleSelectCreateModal}>新規登録</Button>
        </ContentsHeader>

        <div className={styles.row}>
          <section className={styles.rowField}>
            <span className={styles.fieldTitle}>データ種別</span>
            <Radio
              value="vermin"
              {...register('category')}
              onChange={handleChangeCategory}
              defaultChecked={!T_M}
              //defaultChecked={true}
              className={styles.radioText}
            >
              害獣
            </Radio>
            <Radio
              value="trap"
              {...register('category')}
              onChange={handleChangeCategory}
              className={styles.radioText}
            >
              罠
            </Radio>
            <Radio
              value="prevention_faci"
              {...register('category')}
              onChange={handleChangeCategory}
              className={styles.radioText}
              defaultChecked={T_M}
            >
              防止施設
            </Radio>
            <Radio
              value="camera"
              {...register('category')}
              onChange={handleChangeCategory}
              className={styles.radioText}
            >
              カメラ
            </Radio>
            <Radio
              value="damage"
              {...register('category')}
              onChange={handleChangeCategory}
              className={styles.radioText}

            >
              被害
            </Radio>
          </section>

          <section className={clsx(styles.rowField, (watch('category') === "prevention_faci" || watch('category') === "camera") && styles.hidden)}>
            <span className={styles.fieldTitle}>害獣種別</span>
            {Object.entries(vermin_category).map((value) => {
              return(
                <Radio
                  type="checkbox"
                  value={value[0]}
                  {...register("kinds_vermin", { required: true })}
                  className={styles.radioText}>
                  {value[1]}
                </Radio>);
              })}
          </section>
        </div>

        <div className={styles.row}>
          <div className={styles.rowField}>
            <label>
              <span className={styles.labelText}>
                期間
              </span>
            </label>
            <Controller control={control}
              name='start_date' render={({ field: { onChange, value } }) => (
                <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                  locale={ja} name="start_date_2" showMonthDropdown={true} showYearDropdown={true}//230419追加
                  className={styles.input} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
              )} />
            <span className={styles.range}>
              ~
            </span>
            <Controller control={control}
              name='end_date' render={({ field: { onChange, value } }) => (
                <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                  locale={ja} name="end_date_2" showMonthDropdown={true} showYearDropdown={true}//230419追加
                  className={styles.input} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
              )} />
          </div>

          <div className={clsx(styles.rowField, watch('category') !== "vermin" && styles.hidden)}>
            <label>
              <span className={styles.labelText}>時間</span>
            </label>
            <Controller control={control}
              name='occurrence_start' render={({ field: { onChange, value } }) => (
                <DatePicker onChange={onChange} dateFormat="HH:mm" showTimeSelect showTimeSelectOnly timeCaption="Time"
                  locale={ja} name="start_time_2"
                  className={styles.input} placeholderText='00:00' selected={value as unknown as Date} />
              )} />
            <span className={styles.range}>
              ~
            </span>
            <Controller control={control}
              name='occurrence_stop' render={({ field: { onChange, value } }) => (
                <DatePicker onChange={onChange} dateFormat="HH:mm" showTimeSelect showTimeSelectOnly timeCaption="Time"
                  locale={ja} name="end_time_2"
                  className={styles.input} placeholderText='00:00' selected={value as unknown as Date} />
              )} />
          </div>
        </div>
        <div className={styles.row}>
          <div className={clsx(styles.rowField, ( (watch('category') != "vermin" && watch('category') != "damage") || cookie?.verminData?.user_kind_id != 3 ) && styles.hidden)}>
            <label>
              <span className={styles.labelText}>報告書</span>
            </label>
            <Select variant="middle" {...register("report_exist")}>
              <option value={0}>-</option>
              <option value={1}>登録済</option>
              <option value={2}>未登録</option>
            </Select>
          </div>
        </div>

        <div className={styles.row2}>
          {/* {cookie?.verminData?.user_kind_id === 3 &&
            <section className={styles.rowField2}>
              <span className={styles.fieldTitle}>ステータス</span>
              <Radio
                type="checkbox"
                value="0"
                {...register("displayability", { required: true })}
                className={styles.radioText}
              >
                全体公開
              </Radio>
              <Radio
                type="checkbox"
                value="1"
                {...register("displayability", { required: true })}
                className={styles.radioText}

              >
                ログイン閲覧者公開
              </Radio>
              <Radio
                type="checkbox"
                value="2"
                {...register("displayability", { required: true })}
                className={styles.radioText}

              >
                登録修正論理削除権限者公開
              </Radio>
              <Radio
                type="checkbox"
                value="3"
                {...register("displayability", { required: true })}
                className={styles.radioText}

              >
                管理者公開
              </Radio>
            </section>
          } */}
          <div className={styles.rowField}>
            <Button variant="cancel" className={styles.buttonMargin} type="button" onClick={handleSearchReset}>リセット</Button>
            <Button className={styles.buttonMargin} type="submit">検索</Button>
          </div>
        </div>

        {vermins &&
          <Scrollbars className={styles.bottomTable} >
            <>
              {vermins.length === 0 &&
                // (errors?.kinds_vermin?.type === "required" || errors?.displayability?.type === "required") ?
                <div className={styles.text}>条件を指定して検索ボタンを押してください</div>
                // : <div className={styles.errorText}>必須入力となります</div>
              }
              {watch('category') === 'vermin' &&
                <Table >
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>害獣種別</th>
                      <th>発生年月日</th>
                      <th>発生時刻</th>
                      <th>情報分類</th>
                      <th>捕獲方法</th>
                      <th>頭数</th>
                      <th>群れ</th>
                      <th>座標</th>
                      <th>画像</th>{/* 画像20230407追記 */}
                      <th>備考</th>
                      <th>公開範囲</th>
                      {/* <th>削除</th> */}
                      <th>更新日時</th>
                      <th>更新者</th>
                      <th>情報</th>{/*20240416 Update Uduki 編集　⇒　情報*/}
                      <th colSpan={3} className={clsx(cookie?.verminData?.user_kind_id != 3 && styles.hidden)}>報告書</th>{/*20240416 Add Uduki*/}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      vermins?.filter((vermin: Vermin) => !vermin.vermin_is_deleted).map((vermin: Vermin, index: number) => {
                        return (
                          <tr
                            key={`vermin_row_${vermin.vermin_id}`}
                            onClick={(e: any) => {
                              if (e.target.type !== 'checkbox') {
                                e.currentTarget.querySelector("input")?.click()
                              }
                            }}
                          >
                            <td style={{ textAlign: 'center' }}><Radio type="checkbox"  {...register(`id`)} value={`${JSON.stringify(vermin)}`} className={styles.paddingBottom0} disabled={cookie?.verminData?.user_kind_id === 2 && cookie?.verminData?.user_info_id !== vermin.update_user_id} /></td>
                            <td>{vermin.vermin_kind_name}</td>
                            <td>{dayjs(vermin.vermin_discovery_date).format('YYYY/MM/DD')}</td>
                            <td>{dayjs(`${vermin.vermin_discovery_date} ${vermin.vermin_discovery_time}`).format('HH:mm')}</td>
                            <td>{ecology[+vermin.vermin_ecology]}</td>
                            <td>{vermin.trap_hunting_name}</td>
                            <td style={{ textAlign: 'right' }}>{vermin.vermin_count}</td>
                            <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{vermin.vermin_herd}</td>
                            <td>{vermin.vermin_latitude}、{vermin.vermin_longitude}</td>
                            <td><Button variant="edit" onClick={(e) => pictureEditModal(vermin)} disabled={vermin.vermin_picture == null }>画像</Button></td>
                            <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{vermin.vermin_remarks}</td>
                            <td>{vermin.vermin_displayability_name}</td>
                            {/* <td style={{ textAlign: 'center' }}>{vermin.vermin_is_deleted && '○'}</td> */}
                            <td>{vermin.vermin_update_date && dayjs(vermin.vermin_update_date).format('YYYY/MM/DD HH:mm')}</td>
                            <td>{vermin.update_user_name}</td>
                            {/*<td><Button variant="edit" onClick={(e) => handleEdit(e, vermin)} disabled={cookie?.verminData?.user_kind_id <= 2 && cookie?.verminData?.user_info_id !== vermin.update_user_id || vermin.vermin_ecology_name === "観察" || vermin.vermin_ecology_name === "狩猟" || vermin.vermin_ecology_name === "捕獲" || vermin.vermin_ecology_name === "錯誤捕獲"}>編集</Button></td>*/}
                            <td><Button variant="edit" onClick={(e) => handleEdit(e, vermin)} disabled={cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != vermin.update_user_id}>編集</Button></td>
                            <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}>{vermin.report_id && "No."}{vermin.report_id}</td>
                            <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}><Button variant="edit" onClick={(e) => reportPDFDouwnload(e, 1, vermin.vermin_id,vermin.report_id)} disabled={(cookie?.verminData?.user_kind_id < 3 )||(vermin.report_id ? false:true)}>取得</Button></td>{/*20240416 Add Uduki*/}
                            <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}><Button variant="edit" onClick={(e) => handleReportEdit(e, 1, vermin.vermin_id)} disabled={cookie?.verminData?.user_kind_id  < 3 }>編集</Button></td>{/*20240416 Add Uduki*/}
                          </tr>
                        )
                      }
                      )
                    }
                  </tbody>
                </Table>
              }
              {
                watch('category') === 'trap' &&
                <Table>
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>罠ID</th>
                      <th>捕獲方法</th>
                      <th>対象害獣</th>
                      <th>管理者</th>
                      <th>開始時期</th>
                      <th>終了時期</th>
                      <th>捕獲結果</th>
                      <th>座標</th>
                      <th>備考</th>
                      <th>公開範囲</th>
                      {/* <th>削除</th> */}
                      <th>更新日時</th>
                      <th>更新者</th>
                      <th>情報</th>{/*20240416 Update Uduki 編集　⇒　情報*/}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      vermins?.filter((trap: Trap) => !trap.trap_deleted).map((trap: Trap) => (
                        <tr
                          key={`trap_row_${trap.trap_id}`}
                          onClick={(e: any) => {
                            if (e.target.type !== 'checkbox') {
                              e.currentTarget.querySelector("input")?.click()
                            }
                          }}
                        >
                          <td style={{ textAlign: 'center' }}><Radio type="checkbox" {...register(`id`)} value={`${JSON.stringify(trap)}`} className={styles.paddingBottom0} disabled={cookie?.verminData?.user_kind_id === 2 && cookie?.verminData?.user_info_id !== trap.update_user_id} /></td>
                          <td>{trap.trap_id}</td>
                          <td>{trapList[+trap.trap_hunting_id]}</td>
                          <td>{vermin_category[+trap.vermin_kind_id]}</td>
                          <td>{trap.trap_admin}</td>
                          <td>{trap.trap_start && dayjs(trap.trap_start).format('YYYY/MM/DD')}</td>
                          <td>{trap.trap_stop && dayjs(trap.trap_stop).format('YYYY/MM/DD')}</td>
                          <td>{trap.trap_result}</td>
                          <td>{trap.trap_latitude}、{trap.trap_longitude}</td>
                          <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{trap.trap_remarks}</td>
                          <td>{display[+trap.trap_displayability]}</td>
                          {/* <td>{trap.trap_deleted && '○'}</td> */}
                          <td>{trap.trap_update_date && dayjs(trap.trap_update_date).format('YYYY/MM/DD HH:mm')}</td>
                          <td>{trap.update_user_name}</td>
                          <td><Button variant="edit" onClick={(e) => handleEdit(e, trap)} disabled={cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != trap.update_user_id}>編集</Button></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              }
              {
                watch('category') === 'prevention_faci' &&
                <Table>
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>防止施設</th>
                      <th>管理者</th>
                      <th>交付年月日</th>
                      <th>全長(m)</th>
                      <th>備考</th>
                      <th>公開範囲</th>
                      {/* <th>削除</th> */}
                      <th>更新日時</th>
                      <th>更新者</th>
                      <th>編集</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      vermins?.filter((prev: Prevention_faci) => !prev.prev_faci_deleted).map((prevention_faci: Prevention_faci) => (
                        <tr
                          key={`prevention_row_${prevention_faci.prev_faci_id}`}
                          onClick={(e: any) => {
                            if (e.target.type !== 'checkbox') {
                              e.currentTarget.querySelector("input")?.click()
                            }
                          }}
                        >
                          <td style={{ textAlign: 'center' }}><Radio type="checkbox" {...register(`id`)} value={`${JSON.stringify(prevention_faci)}`} className={styles.paddingBottom0} disabled={cookie?.verminData?.user_kind_id === 2 && cookie?.verminData?.user_info_id !== prevention_faci.update_user_id} /></td>
                          <td>{prevention[+prevention_faci.prev_faci_type_id]}</td>
                          <td>{prevention_faci.prev_faci_admin}</td>
                          <td>{prevention_faci.prev_faci_delivery_date && dayjs(prevention_faci.prev_faci_delivery_date).format('YYYY/MM/DD')}</td>
                          <td>{prevention_faci.prev_faci_distance}</td>
                          <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{prevention_faci.prev_faci_remarks}</td>
                          <td>{display[+prevention_faci.prev_faci_displayability]}</td>
                          {/* <td>{prevention_faci.prev_faci_deleted && '○'}</td> */}
                          <td>{prevention_faci.prev_faci_update_date && dayjs(prevention_faci.prev_faci_update_date).format('YYYY/MM/DD HH:mm')}</td>
                          <td>{prevention_faci.update_user_name}</td>
                          <td><Button variant="edit" onClick={(e) => handleEdit(e, prevention_faci)} disabled={cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != prevention_faci.update_user_id}>編集</Button></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              }
              {watch('category') === 'camera' &&
                <Table>
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>カメラID</th>
                      <th>座標</th>
                      <th>撮影向き</th>
                      <th>撮影罠</th>
                      <th>開始時期</th>
                      <th>終了時期</th>
                      <th>備考</th>
                      <th>公開範囲</th>
                      {/* <th>削除</th> */}
                      <th>更新日時</th>
                      <th>更新者</th>
                      <th>情報</th>{/*20240416 Update Uduki 編集　⇒　情報*/}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      vermins?.filter((camera: Camera) => !camera.camera_deleted).map((camera: Camera) => (
                        <tr
                          key={`camera_row_${camera.camera_id}`}
                          onClick={(e: any) => {
                            if (e.target.type !== 'checkbox') {
                              e.currentTarget.querySelector("input")?.click()
                            }
                          }}
                        >
                          <td style={{ textAlign: 'center' }}><Radio type="checkbox" {...register(`id`)} value={`${JSON.stringify(camera)}`} className={styles.paddingBottom0} disabled={cookie?.verminData?.user_kind_id === 2 && cookie?.verminData?.user_info_id !== camera.update_user_id} /></td>
                          <td>{camera.camera_id}</td>
                          <td>{camera.camera_latitude}、{camera.camera_longitude}</td>
                          <td>{camera.camera_direction}</td>
                          <td>{camera.trap_id}</td>
                          <td>{camera.camera_start && dayjs(camera.camera_start).format('YYYY/MM/DD')}</td>
                          <td>{camera.camera_stop && dayjs(camera.camera_stop).format('YYYY/MM/DD')}</td>
                          <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{camera.camera_remarks}</td>
                          <td>{display[+camera.camera_displayability]}</td>
                          {/* <td>{camera.camera_deleted && "○"}</td> */}
                          <td>{camera.camera_update_date && dayjs(camera.camera_update_date).format('YYYY/MM/DD HH:mm')}</td>
                          <td>{camera.update_user_name}</td>
                          <td><Button variant="edit" onClick={(e) => handleEdit(e, camera)} disabled={cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != camera.update_user_id}>編集</Button></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              }
              {
                watch('category') === 'damage' &&
                <Table>
                  <thead>
                    <tr>
                      <th>選択</th>
                      <th>被害物</th>
                      <th>加害獣</th>
                      <th>発生年月日</th>
                      <th>被害内容</th>
                      <th>対策実施</th>
                      <th>座標</th>
                      <th>備考</th>
                      <th>公開範囲</th>
                      {/* <th>削除</th> */}
                      <th>更新日時</th>
                      <th>更新者</th>
                      <th>情報</th>{/*20240416 Update Uduki 編集　⇒　情報*/}
                      <th colSpan={3} className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}>報告書</th>{/*20240416 Add Uduki*/}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      vermins?.filter((damage: Damage) => !damage.damage_deleted).map((damage: Damage) => (
                        <tr
                          key={`damage_row_${damage.damage_id}`}
                          onClick={(e: any) => {
                            if (e.target.type !== 'checkbox') {
                              e.currentTarget.querySelector("input")?.click()
                            }
                          }}
                        >
                          <td style={{ textAlign: 'center' }}><Radio type="checkbox" {...register('id')} value={`${JSON.stringify(damage)}`} className={styles.paddingBottom0} disabled={cookie?.verminData?.user_kind_id === 2 && cookie?.verminData?.user_info_id !== damage.update_user_id} /></td>
                          <td>{damage_category[+damage.damage_type_id]}</td>
                          <td>{vermin_category[+damage.vermin_kind_id]}</td>
                          <td>{damage.damage_discovery_date && dayjs(damage.damage_discovery_date).format('YYYY/MM/DD HH:mm')}</td>
                          <td>{damage.damage_contents}</td>
                          <td>{damage_implementation[+damage.damage_implementation]}</td>
                          <td>{damage.damage_latitude}, {damage.damage_longitude}</td>
                          <td className={styles.remarks_hidden} style={{maxWidth : resize_x}}>{damage.damage_remarks}</td>
                          <td>{display[+damage.damage_displayability]}</td>
                          {/* <td>{damage.damage_deleted}</td> */}
                          <td>{damage.damage_update_date && dayjs(damage.damage_update_date).format('YYYY/MM/DD HH:mm')}</td>
                          <td>{damage.update_user_name}</td>
                          <td><Button variant="edit" onClick={(e) => handleEdit(e, damage)} disabled={cookie?.verminData?.user_kind_id == 2 && cookie?.verminData?.user_info_id != damage.update_user_id}>編集</Button></td>
                          <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}>{damage.report_id && "No."}{damage.report_id}</td>
                          <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}><Button variant="edit" onClick={(e) => reportPDFDouwnload(e, 2, damage.damage_id, damage.report_id)} disabled={(cookie?.verminData?.user_kind_id < 3) || (damage.report_id ? false:true)}>取得</Button></td>{/*20240416 Add Uduki*/}
                          <td className={clsx( cookie?.verminData?.user_kind_id != 3 && styles.hidden)}><Button variant="edit" onClick={(e) => handleReportEdit(e, 2, damage.damage_id)} disabled={cookie?.verminData?.user_kind_id  < 3}>編集</Button></td>{/*20240416 Add Uduki*/}
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              }
            </>
          </Scrollbars>
        }

        <div className={styles.between}>
          <div className={styles.radioBox}>
            <Radio {...register('all')} value="1" onChange={handleAllSelect} disabled={vermins.length === 0} className={styles.radioTextLeftMargin}
            >全解除</Radio>
            <Radio {...register('all')} value="2" onChange={handleAllSelect} className={styles.radioTextLeftMargin} disabled={vermins.length === 0}
            >全選択</Radio>
          </div>
          <div style={{ position: "relative" }}>
            <Button onClick={() => { setIsPulldownModal(!isPulldownModal) }} className={clsx(styles.longButton, operationValue === "削除" && styles.confirmText)}>{operationValue || "選択してください"}</Button>
            {isPulldownModal &&
              <>
                <div className={styles.pulldownModal}>
                  {cookie?.verminData?.user_kind_id === 3 &&
                    <>
                      <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="全体公開">公開</button>
                      <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="ログイン閲覧者公開">ログイン閲覧者公開</button>
                      <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</button>
                      <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="管理者公開">管理者公開</button>
                    </>
                  }
                  <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="CSVダウンロード">CSVダウンロード</button>
                  <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="表示情報一括ダウンロード">表示情報一括ダウンロード</button>
                  <button type="button" onClick={handleSelect} className={styles.pulldownButton} value="削除">削除</button>
                </div>
                <div className={styles.pulldownOverlay} onClick={() => setIsPulldownModal(false)}></div>
              </>
            }
          </div>

          <Button type="button" className={styles.buttonMargin} disabled={((watch('id')?.length === 0 || !watch('id')) || operationValue === '') && (!(operationValue === '表示情報一括ダウンロード')||(vermins.length === 0))} onClick={handleExecution}>選択済みを対象に一括操作実行</Button>
        </div>
      </ContentsLayout>
    </form>
  );
};

export default Data;
